export default __webpack_public_path__ + "static/media/portfolio-164.f07891d2.jpg";